import { createFileRoute } from '@tanstack/react-router'

import { PersonalInformationsPage } from '@/components/personal-informations/personal-informations-page'

export const Route = createFileRoute('/_authenticated/_layout/informations-personnelles')({
  component: PersonalInformationsPage,
})
